import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@massilia/ui';
import { useState } from 'react';
let popoverZIndexCounter = 2147483000;
export function FieldError({ className, asPopover, asPopoverSide = 'bottom', asString, errors, }) {
    const message = asString ? errors.map((error) => error).join(', ') : errors.at(0)?.message;
    // Assign a decreasing z-index (once, at mount) to ensure first mounted popovers
    // appear on top. Initialiseur paresseux de `useState`, qui ne s'exécute qu'au tout
    // premier rendu, plutôt qu'un `setState` synchrone dans un effet.
    const [zIndex] = useState(() => asPopover ? popoverZIndexCounter-- : undefined);
    if (asPopover) {
        return (errors.length > 0 && (_jsxs("div", { className: cn('pointer-events-none absolute left-0 z-30 w-max max-w-full rounded-md px-2 py-1.5 shadow-lg', {
                'bottom-full mb-2': asPopoverSide === 'top',
                'top-full mt-2': asPopoverSide === 'bottom',
            }, {
                hidden: !errors.length,
            }), style: { backgroundColor: '#dc2626', color: '#ffffff', zIndex }, children: [_jsx("div", { className: cn('absolute left-3 h-0 w-0', {
                        'bottom-0 translate-y-full border-t-[6px] border-r-[6px] border-l-[6px] border-t-red-600 border-r-transparent border-l-transparent': asPopoverSide === 'top',
                        'top-0 -translate-y-full border-r-[6px] border-b-[6px] border-l-[6px] border-r-transparent border-b-red-600 border-l-transparent': asPopoverSide === 'bottom',
                    }) }), _jsx("p", { className: "text-xs text-wrap text-white", role: "alert", children: message })] })));
    }
    return errors.length > 0 ? (_jsx("em", { className: cn('text-destructive text-sm', className), role: "alert", children: message })) : null;
}
